import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

// PATCH — flat partial changes; only the sent fields change on the table.
export const patchUpdateSaleInvoiceInstalmentTable = async (
  projectId,
  instalmentTableId,
  changes
) => {
  const apiPath = `invoice/${projectId}/sale-invoice-instalment-tables/${instalmentTableId}`;

  const body = changes;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    data: body,
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PATCH',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
